import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeMultipleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapeMultiple" ref={ref} {...props}>
    <path d="M16,2.14A6.76,6.76,0,0,0,9.46,7.25H7A3.75,3.75,0,0,0,3.26,11v6A3.75,3.75,0,0,0,7,20.74h6A3.76,3.76,0,0,0,16.75,17v-1.4A6.75,6.75,0,0,0,16,2.14ZM15.25,17A2.25,2.25,0,0,1,13,19.24H7A2.25,2.25,0,0,1,4.76,17V11A2.25,2.25,0,0,1,7,8.75H9.26a.66.66,0,0,0,0,.14,6.75,6.75,0,0,0,6,6.7Zm0-2.91a5.25,5.25,0,0,1-4.5-5.19.66.66,0,0,1,0-.14H13A2.25,2.25,0,0,1,15.25,11Zm1.5,0V11A3.76,3.76,0,0,0,13,7.25H11a5.25,5.25,0,1,1,5.73,6.83Z" />
  </Icon>
)) as IconWithRender;

ShapeMultipleIcon.displayName = 'ShapeMultipleIcon';
ShapeMultipleIcon.renderIcon = (props) => <ShapeMultipleIcon {...props} />;
export default ShapeMultipleIcon;
